export default __webpack_public_path__ + "img/d07622bd030bebfe868c1dbff6c03e1c.png";